module.exports = __webpack_public_path__ + "static/img/male-6.1ab139f0.png";